import { render, staticRenderFns } from "./forgot-password-form.vue?vue&type=template&id=c0d283d6&"
import script from "./forgot-password-form.vue?vue&type=script&lang=ts&"
export * from "./forgot-password-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports